"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _wrapper = require("../../components/wrapper");

var _wrapper2 = _interopRequireDefault(_wrapper);

var _slice = require("../../components/slice");

var _slice2 = _interopRequireDefault(_slice);

var _pie = require("../../components/pie");

var _pie2 = _interopRequireDefault(_pie);

require("./oneunit.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// static values to supply for wrapper
var c_values = ["c2"];
var p_values = ["p2"];

// Slice-pie wrapper for equal parts
var SlicePieWrapperForEqaulParts = function SlicePieWrapperForEqaulParts(props) {
  var wrapper = c_values.map(function (item, index) {
    return _react2.default.createElement(
      _react2.default.Fragment,
      { key: index },
      _react2.default.createElement(
        _slice2.default,
        { clipnative: true, slicedegree: 180 * (index + 1) },
        _react2.default.createElement(_pie2.default, {
          mainbg: props.bgclr,
          clipnative: true,
          widthoffset: props.widthoffset,
          piebg: props.paintShades[c_values[index]],
          degree: "360"
        })
      )
    );
  });

  return wrapper;
};

// Slice-pie wrapper for in-equal parts
var SlicePieWrapperForIneqaulParts = function SlicePieWrapperForIneqaulParts(props) {
  // static values to supply for wrapper
  var wrapper = c_values.map(function (item, index) {
    return _react2.default.createElement(
      _react2.default.Fragment,
      { key: index },
      _react2.default.createElement(
        _slice2.default,
        {
          clipnative: true,
          slicedegree: 180 * (index + 1) - props.pValue[p_values[index]],
          z_axis: props.pValue[p_values[index]]
        },
        _react2.default.createElement(_pie2.default, {
          mainbg: props.bgclr,
          clipnative: true,
          widthoffset: props.widthoffset,
          piebg: props.paintShades[c_values[index]],
          degree: 360 + props.pValue[p_values[index]]
        })
      )
    );
  });
  return wrapper;
};

var MultipleDoughnutWrapper = function MultipleDoughnutWrapper(props) {
  var chartSize = props.chartSize;
  if (chartSize === "large") {
    return _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(_wrapper2.default, { donutwidth: "220", setpos: "40" }),
      _react2.default.createElement(_wrapper2.default, {
        className: "modified_large_wrapper",
        donutwidth: "240",
        setpos: "40"
      })
    );
  } else if (chartSize === "medium") {
    return _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(_wrapper2.default, { donutwidth: "155", setpos: "74" }),
      _react2.default.createElement(_wrapper2.default, {
        className: "modified_medium_wrapper",
        donutwidth: "175",
        setpos: "74"
      })
    );
  } else if (chartSize === "small") {
    return _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(_wrapper2.default, { donutwidth: "110", setpos: "95" })
    );
  }
};

var Circle = function Circle(props) {
  var _props$pievalues = props.pievalues,
      p1 = _props$pievalues.p1,
      p2 = _props$pievalues.p2,
      p3 = _props$pievalues.p3,
      p4 = _props$pievalues.p4,
      p5 = _props$pievalues.p5;

  var paintShadesRemaining = { p2: p2, p3: p3, p4: p4, p5: p5 };
  return _react2.default.createElement(
    "div",
    null,
    props.shouldRemainEqual ? _react2.default.createElement(
      "div",
      { style: { position: "relative" } },
      _react2.default.createElement(
        _slice2.default,
        { slicedegree: "0" },
        _react2.default.createElement(_pie2.default, {
          mainbg: props.bgclr,
          widthoffset: props.widthoffset,
          piebg: props.paintShades.c1,
          degree: "360"
        })
      ),
      _react2.default.createElement(SlicePieWrapperForEqaulParts, props)
    ) : _react2.default.createElement(
      "div",
      { className: "wrapper", style: { position: "relative" } },
      _react2.default.createElement(
        _slice2.default,
        { piebg: "yellow" },
        _react2.default.createElement(
          _slice2.default,
          { slicedegree: 0 - p1 },
          _react2.default.createElement(_pie2.default, {
            mainbg: props.bgclr,
            widthoffset: props.widthoffset,
            piebg: props.paintShades.c1,
            degree: 360 + p1
          })
        ),
        _react2.default.createElement(SlicePieWrapperForIneqaulParts, {
          widthoffset: props.widthoffset,
          pValue: paintShadesRemaining,
          paintShades: props.paintShades,
          bgclr: props.bgclr
        })
      )
    ),
    _react2.default.createElement(MultipleDoughnutWrapper, { chartSize: props.chartSize })
  );
};

Circle.propTypes = {
  shouldRemainEqual: _propTypes2.default.bool,
  pievalues: _propTypes2.default.object,
  paintShades: _propTypes2.default.object,
  bgclr: _propTypes2.default.string
};

exports.default = Circle;